export default "__VITE_ASSET__ZIL9lG5K__"